import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';

import { commonStyles } from '../../styles/styles';

const RenderEmail = ({ classes, input, meta, registrationForm }) => {
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      className={`${classes.formField} ${registrationForm ? classes.regField : false}`}
      aria-describedby="name-error-text"
      error={conditionError}
    >
      {console.log('EMAIL', input)}
      <Input
        {...input}
        name="Email"
        label="User email"
        placeholder="User email"
        className={`${classes.formInput} ${conditionError ? classes.inputError : false}`}
        disableUnderline
        error={conditionError}
        classes={{ focused: classes.formInputFocus }}
      />
      {conditionError && (
        <FormHelperText id="name-error-text" className={classes.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(RenderEmail);



// WEBPACK FOOTER //
// ./src/Components/Form/AddUserEmailField.jsx